import React, { PropTypes } from 'react'

const Oops = ({ meta }) => {
    return <div className="container-fluid">
        <br />
        <div className="container-fluid">
            <div className="notice notice-warning">
                <div className="notice-content">There was problem loading <strong>{meta.name}</strong> module, please try again.</div>
            </div>
        </div>
    </div>
}

Oops.propTypes = {
    meta: PropTypes.object.isRequired
}

export default Oops